// This file has been generated from LT.Core.LocationFilterSetting
export enum LocationFilterSetting {

  
   Auto = 0,
   Prevent = 1,
   Clear = 2,
   ZoomCountry = 3

}
export default LocationFilterSetting;